export const ADD_TEAM = 'Add team';
export const EDIT_TEAM = 'Edit team';
export const CREATE_ROLE = 'Create role';
export const EDIT_ROLE = 'Edit role permissions';
export const AGENT_USER = 'Agent user permissions';
export const SUPER_ADMIN = 'Admin'; // Global Account Manager
export const CLONE_ROLE = 'Clone role';
export const CREATE_USER = 'Add user';
export const EDIT_USER = 'Edit Users';
export const CREATE_TEAM = 'Create new team';
export const VERIFY_NEW_DOMAIN = 'Verify new domain';
export const AUTHENTICATE_DOMAIN = 'Authenticate domain';
export const CREATE_LOCATION = 'Create Location';
export const EDIT_LOCATION = 'Edit Location';
export const EDIT_LICENSE_ASSIGNMENT = 'Edit license assignment';
